import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { CoachNewPropertyDialog } from "../../Partials/Dialog/CoachNewPropertyDialog";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { TableComponent } from "../../Partials/Table/TableComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { TabsComponent } from "./TabsComponent";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

class Properties extends Component {
  protected selectedProperty: PropertyInterface;

  public state = {
    isPromptOpen: false,
    entity: null,
    isCreateTasksFromActivityTemplatePopupOpen: false,
    currentProperty: null,
    currentActivityTemplate: null,
    anchorEl: null,
    isNewTaskPopupOpen: false,
    isSaving: false,
    openCoachCreateNewProperty: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdExecutor = this.props.app.savedDataBeforeRedirecting.createdExecutor;

      const state = {
        ...this.props.app.savedDataBeforeRedirecting.propertiesDataToBeSaved,
        executorId: !!createdExecutor && !!this.props.app.savedDataBeforeRedirecting.propertiesDataToBeSaved && !!this.props.app.savedDataBeforeRedirecting.propertiesDataToBeSaved.isCreateTaskPopupOpen ? createdExecutor.id : !!this.props.app.savedDataBeforeRedirecting.propertiesDataToBeSaved && this.props.app.savedDataBeforeRedirecting.propertiesDataToBeSaved.selectedPerson,
      }

      this.setState({
        ...state
      }, () => {
        this.setState({hasModifiedData: true}, () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
        });
      });
    }
  }

  protected propertyDelete = (property: PropertyInterface) => {
    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_DELETE_START,
      payload: {
        property: property
      }
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public propertyComparer = (a, b) => {
    return this.comparer(a.address.locality, b.address.locality) ||
      this.comparer(a.address.route, b.address.route) ||
        this.comparer(a.address.formattedAddress, b.address.formattedAddress);
  }

  protected openMenu = (event: any, property: PropertyInterface): void => {
    this.selectedProperty = property;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  protected getProperties = () => {
    return Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties.byId[id])
    .filter((property: PropertyInterface) => property.removed === false)
    .sort(this.propertyComparer)
    .map((property: PropertyInterface, key: number) => {
      if (!property) {
        return;
      }

      return (
        <TableRow
          hover
          key={key}
          className={`clickable-entity`}
          onClick={() => {
            this.redirect(`/app/property/update/${property.id}`);
          }}
        >
          {/* <TableCell>
            <SubscriptionIcon entity={property} {...this.props}/>
          </TableCell> */}
          <TableCell style={{width: "50px"}}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
              {property.renderAvatar()}
            </div>
          </TableCell>
          <TableCell style={{width: "55%"}}>{property.displayName}</TableCell>
          <TableCell style={{width: "30%"}}>{property.company ? property.company.name : ""}</TableCell>
          <TableCell style={{width: "15%"}}>{property.units.length > 1 || property.units.length === 0 ?
            this.trans("title-units-amount", { amount: property.units && property.units.length ? property.units.length : 0 })
            :
            this.trans("title-unit-amount", { amount: property.units && property.units.length})
          }
          </TableCell>
          <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, property)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedProperty && this.selectedProperty.id === property.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/property/update/${this.selectedProperty.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.prompt(this.selectedProperty)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                  <Divider/>
                  {/* <MenuItem
                      onClick={() => this.setState({isNewTaskPopupOpen: true})}
                    >
                      <ListItemIcon><div className="icon icon-ic-task aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                    </MenuItem> */}
                    {/* {this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (<Divider/>)}
                    {
                      this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                        this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).map((activityTemplate, key: number) => {
                          return (
                            <MenuItem
                              key={`activity-${key}`}
                              onClick={() => this.setState({isCreateTasksFromActivityTemplatePopupOpen: true, currentProperty: this.selectedProperty, currentActivityTemplate: activityTemplate, anchorEl: null})}
                            >
                              <ListItemIcon><div className="icon icon-ic-activity aligned"></div></ListItemIcon>
                              <ListItemText>{activityTemplate.name}</ListItemText>
                            </MenuItem>
                          )
                        })
                      )
                    } */}
                </Menu>
              </div>
            </TableCell>
        </TableRow>
      );
    });
  }

  protected prompt = (entity: any): void => {
    this.setState({
      isPromptOpen: true,
      entity: entity,
      anchorEl: null
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isPromptOpen: false
    });
  }

  public delete = (): void => {
    this.closePrompt();

    if (this.state.entity.nameOfEntity === this.trans("property")) {
      return this.propertyDelete(this.state.entity);
    }
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-properties has-general-page-header with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <div style={{padding: "0 40px", display: "flex", justifyContent: "space-between"}}>
            <h1 style={{padding: "24px 0"}}>{this.trans("title-addresses")}</h1>
              {/* <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({openCoachCreateNewProperty: true})}
                >
                  {this.trans("button-new-property")}
                </Button>
              </div> */}
            </div>
            <TabsComponent
              activeTab={1}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <div>
              <TableComponent
                {...this.props}
                className="listing-table"
                paginator={{
                  name: "Properties",
                  path: this.props.app.paginator
                }}
                dispatch={this.props.dispatch}
                entities={Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties.byId[id])}
                isFetched={this.props.app.loadedEntities.includes(Constants.GLOBAL_PROPERTY_LIST_SUCCESS)}
                rows={this.getProperties()}
                isChildListingTable={false}
                subtitle={this.trans("no-properties-to-list-for-property")}
                ignoreFirstCellClick={true}
              />
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("create-tasks-for", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : ""})}
          content={this.trans("you-are-about-to-create-task-for-activity-for-property", {activityTemplate : this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "", property: this.state.currentProperty ? this.state.currentProperty.displayName : ""})}
          openLeavePrompt={this.state.isCreateTasksFromActivityTemplatePopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("create-tasks")}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }); }}
          onSave={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }, () => {
            this.props.dispatch({
              type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
              payload: {
                propertyId: this.state.currentProperty && this.state.currentProperty.id
              }
            });

            this.redirect(`/app/activity/create/${this.state.currentActivityTemplate && this.state.currentActivityTemplate.id}/${this.state.currentProperty && this.state.currentProperty.id}/0`);
          })}}
          hideCross={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          isOpen={this.state.isPromptOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <CreateTaskDialog 
          {...this.props}
          entity={this.selectedProperty}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false, 
              anchorEl: null
            })
          }}
        />

        <CoachNewPropertyDialog
          {...this.props}
          openCoachCreateNewProperty={this.state.openCoachCreateNewProperty}
          onClosePropertyCoach={(property) => {
            this.setState({
              openCoachCreateNewProperty: false,
              ownerCreateByCoach: null
            })
            if (property?.id) {
              this.redirect(`/app/property/update/${property.id}`);
            }
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    component: state.propertiesPage,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Properties
);
